// import { Box, Container, Typography } from "@mui/material";

// import {
//     FaAward,
//     FaClock,
//     FaLeaf,
//     FaShieldAlt,
//     FaSmile,
//     FaTruck,
// } from "react-icons/fa";

// import aboutImage from "../../assets/images/why-right.png";
// import whyChooseBgM from "../../assets/images/why-bg-m.png";
// import whyChooseBg from "../../assets/images/why-bg.png";

// const features = [
//   {
//     icon: <FaTruck />,
//     title: "Free Pickup & Delivery",
//     desc: "Convenient doorstep collection and delivery at no extra cost.",
//   },

//   {
//     icon: <FaClock />,
//     title: "Same Day Service",
//     desc: "Fast turnaround without compromising quality.",
//   },

//   {
//     icon: <FaLeaf />,
//     title: "Eco Friendly Cleaning",
//     desc: "Safe cleaning solutions for garments and the environment.",
//   },

//   {
//     icon: <FaAward />,
//     title: "Premium Garment Care",
//     desc: "Expert handling of delicate and luxury fabrics.",
//   },

//   {
//     icon: <FaShieldAlt />,
//     title: "Quality Guarantee",
//     desc: "Every item inspected for spotless results.",
//   },

//   {
//     icon: <FaSmile />,
//     title: "5000+ Happy Customers",
//     desc: "Trusted by families and professionals across Ajax.",
//   },
// ];

// function WhyChooseUs() {
//   return (
//     <Box
//       sx={{
//         backgroundImage: {
//           xs: `url(${whyChooseBgM})`,
//           md: `url(${whyChooseBg})`,
//         },

//         backgroundSize: "cover",

//         backgroundPosition: "center",

//         backgroundRepeat: "no-repeat",

//         py: {
//           xs: 8,
//           md: 12,
//         },

//         overflow: "hidden",
//       }}
//     >
//       <Container maxWidth="xl">
//         <Box
//           sx={{
//             display: "flex",

//             flexDirection: {
//               xs: "column",
//               lg: "row",
//             },

//             alignItems: "center",

//             gap: {
//               xs: 6,
//               md: 10,
//             },
//           }}
//         >
//           {/* LEFT */}

//           <Box
//             sx={{
//               flex: 1,

//               width: "100%",
//             }}
//           >
//             <Box
//               sx={{
//                 display: "inline-flex",

//                 alignItems: "center",

//                 px: 3,

//                 py: 1,

//                 borderRadius: "50px",

//                 background: "rgba(255,255,255,.85)",

//                 backdropFilter: "blur(12px)",

//                 border: "1px solid rgba(0,87,255,.08)",

//                 color: "#0057ff",

//                 fontWeight: 700,

//                 textTransform: "uppercase",

//                 letterSpacing: "1px",

//                 fontSize: {
//                   xs: "11px",
//                   md: "12px",
//                 },

//                 mb: 2,
//               }}
//             >
//               Why Choose Comet Cleaners
//             </Box>

//             <Typography
//               sx={{
//                 fontWeight: 800,

//                 lineHeight: 1.08,

//                 color: "#0f172a",

//                 fontSize: {
//                   xs: "34px",
//                   md: "58px",
//                 },
//               }}
//             >
//               Premium Care.
//               <br />
//               Exceptional Results.
//             </Typography>

//             <Typography
//               sx={{
//                 mt: 2.5,

//                 color: "#64748b",

//                 lineHeight: 1.9,

//                 fontSize: {
//                   xs: "15px",
//                   md: "18px",
//                 },

//                 maxWidth: "650px",
//               }}
//             >
//               We combine modern cleaning technology, professional garment care
//               and outstanding customer service to deliver a luxury laundry
//               experience every time.
//             </Typography>

//             {/* FEATURES */}

//             <Box
//               sx={{
//                 mt: 5,

//                 display: "flex",

//                 flexWrap: "wrap",

//                 gap: 2,
//               }}
//             >
//               {features.map((item, index) => (
//                 <Box
//                   key={index}
//                   sx={{
//                     width: {
//                       xs: "100%",
//                       md: "48%",
//                     },

//                     display: "flex",

//                     alignItems: "center",

//                     gap: 2,

//                     p: 2,

//                     borderRadius: "20px",

//                     background: "rgba(255,255,255,.72)",

//                     backdropFilter: "blur(15px)",

//                     border: "1px solid rgba(0,87,255,.08)",

//                     transition: ".3s",

//                     "&:hover": {
//                       transform: "translateY(-4px)",

//                       boxShadow: "0 20px 40px rgba(0,87,255,.10)",
//                     },
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       width: 56,

//                       height: 56,

//                       borderRadius: "50%",

//                       background: "linear-gradient(135deg,#0057ff,#2f8cff)",

//                       color: "#fff",

//                       display: "flex",

//                       alignItems: "center",

//                       justifyContent: "center",

//                       fontSize: "22px",

//                       flexShrink: 0,
//                     }}
//                   >
//                     {item.icon}
//                   </Box>

//                   <Box>
//                     <Typography
//                       sx={{
//                         fontWeight: 700,

//                         color: "#0f172a",

//                         fontSize: {
//                           xs: "16px",
//                           md: "18px",
//                         },
//                       }}
//                     >
//                       {item.title}
//                     </Typography>

//                     <Typography
//                       sx={{
//                         color: "#64748b",

//                         fontSize: "14px",

//                         mt: 0.5,
//                       }}
//                     >
//                       {item.desc}
//                     </Typography>
//                   </Box>
//                 </Box>
//               ))}
//             </Box>
//           </Box>

//           {/* RIGHT IMAGE */}

//           <Box
//             sx={{
//               flex: 1,

//               width: "100%",

//               display: "flex",

//               justifyContent: "center",

//               position: "relative",
//             }}
//           >
//             <Box
//               component="img"
//               src={aboutImage}
//               alt="Why Choose Us"
//               sx={{
//                 width: "100%",

//                 maxWidth: "650px",

//                 borderRadius: "32px",

//                 display: "block",
//               }}
//             />

//             {/* 5000+ */}

//             <Box
//               sx={{
//                 position: "absolute",

//                 top: {
//                   xs: 20,
//                   md: 30,
//                 },

//                 left: {
//                   xs: 10,
//                   md: 20,
//                 },

//                 px: 3,

//                 py: 2,

//                 borderRadius: "22px",

//                 background: "rgba(255,255,255,.92)",

//                 backdropFilter: "blur(12px)",

//                 boxShadow: "0 15px 40px rgba(0,87,255,.12)",
//               }}
//             >
//               <Typography
//                 sx={{
//                   fontWeight: 800,

//                   color: "#0057ff",

//                   fontSize: {
//                     xs: "22px",
//                     md: "30px",
//                   },
//                 }}
//               >
//                 5000+
//               </Typography>

//               <Typography
//                 sx={{
//                   color: "#64748b",

//                   fontSize: "13px",
//                 }}
//               >
//                 Happy Customers
//               </Typography>
//             </Box>

//             {/* EXPERIENCE */}

//             <Box
//               sx={{
//                 position: "absolute",

//                 bottom: {
//                   xs: 20,
//                   md: 30,
//                 },

//                 right: {
//                   xs: 10,
//                   md: 20,
//                 },

//                 px: 3,

//                 py: 2,

//                 borderRadius: "22px",

//                 background: "rgba(255,255,255,.92)",

//                 backdropFilter: "blur(12px)",

//                 boxShadow: "0 15px 40px rgba(0,87,255,.12)",
//               }}
//             >
//               <Typography
//                 sx={{
//                   fontWeight: 800,

//                   color: "#0057ff",

//                   fontSize: {
//                     xs: "22px",
//                     md: "30px",
//                   },
//                 }}
//               >
//                 10+
//               </Typography>

//               <Typography
//                 sx={{
//                   color: "#64748b",

//                   fontSize: "13px",
//                 }}
//               >
//                 Years Experience
//               </Typography>
//             </Box>
//           </Box>
//         </Box>
//       </Container>
//     </Box>
//   );
// }

// export default WhyChooseUs;

import React from "react";

import { Box, Container, Typography } from "@mui/material";

import {
  FaTruck,
  FaClock,
  FaLeaf,
  FaAward,
  FaShieldAlt,
  FaSmile,
  FaUserTie,
  FaCog,
  FaCheckCircle,
} from "react-icons/fa";

import whyChooseBg from "../../assets/images/why_bg_ft.png";
import whyChooseBgm from "../../assets/images/why_bg_ft_m.png";
import cardBg from "../../assets/images/cardBg_c.png";
import cardBgB from "../../assets/images/cardBg_b.png";
import whyChooseImage from "../../assets/images/why-right.png";

const features = [
  {
    icon: <FaTruck />,
    title: "Free Pickup & Delivery",
    desc: "Convenient collection and delivery designed around your schedule.",
  },

  {
    icon: <FaClock />,
    title: "Same Day Service",
    desc: "Fast turnaround for urgent cleaning, alterations and repairs.",
  },

  {
    icon: <FaLeaf />,
    title: "Eco Friendly Cleaning",
    desc: "Safe cleaning solutions for your belongings and the environment.",
  },

  {
    icon: <FaAward />,
    title: "Cleaning, Repairs & Printing",
    desc: "Everything from garment care to printing and specialty services.",
  },

  {
    icon: <FaShieldAlt />,
    title: "Quality Guarantee",
    desc: "Cleaning, Repairs & Printing",
  },

  {
    icon: <FaSmile />,
    title: "5000+ Happy Customers",
    desc: "Trusted by families and businesses throughout Ajax and beyond.",
  },
];

function WhyChooseUs() {
  return (
    <Box
      sx={{
        backgroundImage: {
          xs: `url(${whyChooseBgm})`,
          md: `url(${whyChooseBg})`,
        },
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",

        py: {
          xs: 4,
          md: 6,
        },

        overflow: "hidden",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",

            flexDirection: {
              xs: "column",
              lg: "row",
            },

            alignItems: "center",

            gap: {
              xs: 6,
              lg: 8,
            },
          }}
        >
          {/* LEFT */}

          <Box
            sx={{
              flex: 1,

              width: "100%",
            }}
          >
            {/* Badge */}

            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1,

                px: {
                  xs: 2,
                  md: 2.8,
                },

                py: {
                  xs: 0.8,
                  md: 1,
                },

                borderRadius: "999px",

                background: "linear-gradient(180deg,#ffffff,#f5f9ff)",

                border: "1px solid rgba(0,87,255,.12)",

                boxShadow: "0 10px 30px rgba(0,87,255,.08)",

                color: "#0057ff",

                fontWeight: 700,

                letterSpacing: "1.2px",

                textTransform: "uppercase",

                fontSize: {
                  xs: "8px",
                  md: "10px",
                },

                width: "fit-content",
              }}
            >
              ✦ WHY CHOOSE COMET CLEANERS
            </Box>
            {/* Heading */}

            <Typography
              sx={{
                mt: 2,

                fontWeight: 800,

                lineHeight: 1.05,

                letterSpacing: "-2px",

                fontSize: {
                  xs: "40px",
                  sm: "52px",
                  md: "56px",
                  lg: "68px",
                },
              }}
            >
              <Box
                component="span"
                sx={{
                  color: "#0f172a",
                }}
              >
                Premium Care.
              </Box>

              <br />

              <Box
                component="span"
                sx={{
                  background: "linear-gradient(135deg,#0057ff,#2f8cff)",

                  WebkitBackgroundClip: "text",

                  WebkitTextFillColor: "transparent",
                }}
              >
                Exceptional Results.
              </Box>
            </Typography>

            {/* Text */}

            <Typography
              sx={{
                mt: 2,

                maxWidth: "560px",

                color: "#64748b",

                lineHeight: 1.8,

                fontWeight: 400,

                fontSize: {
                  xs: "14px",
                  md: "16px",
                },
              }}
            >
              We combine professional cleaning, alterations, shoe repair, custom
              printing and specialty care services with outstanding customer
              support to deliver exceptional quality, convenience and reliable
              results all under one roof.
            </Typography>

            {/* Feature Cards */}

            <Box
              sx={{
                mt: {
                  xs: 3,
                  md: 5,
                },

                display: "flex",

                flexWrap: "wrap",

                gap: {
                  xs: 1.5,
                  md: 2,
                },
              }}
            >
              {features.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    position: "relative",

                    width: {
                      xs: "100%",
                      sm: "calc(50% - 8px)",
                    },

                    minHeight: {
                      xs: "95px",
                      md: "110px",
                    },

                    p: {
                      xs: 1.8,
                      md: 2.2,
                    },

                    pl: {
                      xs: 2.5,
                      md: 3,
                    },

                    borderRadius: {
                      xs: "18px",
                      md: "22px",
                    },

                    backgroundImage: `
          // linear-gradient(
          //   rgba(255,255,255,.92),
          //   rgba(248,251,255,.86)
          // ),
          url(${cardBg})
        `,

                    backgroundSize: "cover",

                    backgroundPosition: "center",

                    backdropFilter: "blur(20px)",

                    border: "1px solid rgba(255,255,255,.75)",

                    display: "flex",

                    alignItems: "center",

                    gap: {
                      xs: 1.5,
                      md: 2,
                    },

                    overflow: "hidden",

                    boxShadow:
                      "0 10px 40px rgba(0,87,255,.08), inset 0 1px 0 rgba(255,255,255,.9)",

                    transition: "all .35s ease",

                    "&::before": {
                      content: '""',

                      position: "absolute",

                      left: 0,

                      top: 18,

                      bottom: 18,

                      width: "4px",

                      borderRadius: "20px",

                      background:
                        "linear-gradient(180deg,#0057ff,#66b3ff,#0057ff)",

                      transition: ".35s",
                    },

                    "&:hover": {
                      transform: "translateY(-6px)",

                      boxShadow: "0 25px 60px rgba(0,87,255,.14)",

                      "&::before": {
                        width: "6px",
                      },
                    },
                  }}
                >
                  {/* ICON */}

                  <Box
                    sx={{
                      width: {
                        xs: 50,
                        md: 58,
                      },

                      height: {
                        xs: 50,
                        md: 58,
                      },

                      borderRadius: "50%",

                      background: "linear-gradient(135deg,#0057ff,#2f8cff)",

                      color: "#fff",

                      display: "flex",

                      alignItems: "center",

                      justifyContent: "center",

                      flexShrink: 0,

                      fontSize: {
                        xs: "18px",
                        md: "22px",
                      },

                      border: "2px solid rgba(255,255,255,.5)",

                      boxShadow: "0 12px 30px rgba(0,87,255,.25)",
                    }}
                  >
                    {item.icon}
                  </Box>

                  {/* CONTENT */}

                  <Box>
                    <Typography
                      sx={{
                        fontWeight: 700,

                        color: "#0f172a",

                        lineHeight: 1.2,

                        fontSize: {
                          xs: "15px",
                          md: "18px",
                        },

                        mb: 0.5,
                      }}
                    >
                      {item.title}
                    </Typography>

                    <Typography
                      sx={{
                        color: "#64748b",

                        lineHeight: 1.5,

                        fontSize: {
                          xs: "12px",
                          md: "14px",
                        },
                      }}
                    >
                      {item.desc}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>

            {/* Bottom Trust Bar */}

            <Box
              sx={{
                mt: 3,

                p: {
                  xs: 2,
                  md: 2.5,
                },

                borderRadius: "20px",

                background: "rgba(255,255,255,.85)",
                backgroundImage: `url(${cardBgB})`,
                backgroundSize: "cover",

                backgroundPosition: "center",
                backdropFilter: "blur(18px)",

                border: "1px solid rgba(0,87,255,.08)",

                display: "flex",

                flexDirection: {
                  xs: "column",
                  md: "row",
                },

                alignItems: "center",

                justifyContent: "space-between",

                gap: {
                  xs: 1.5,
                  md: 2,
                },

                maxWidth: "700px",
              }}
            >
              {[
                {
                  icon: <FaUserTie />,
                  title: "Trusted Professionals",
                },
                {
                  icon: <FaCog />,
                  title: "Expert Craftsmanship",
                },
                {
                  icon: <FaShieldAlt />,
                  title: "Satisfaction Guaranteed",
                },
              ].map((item, index) => (
                <React.Fragment key={index}>
                  <Box
                    sx={{
                      display: "flex",

                      alignItems: "center",

                      justifyContent: {
                        xs: "center",
                        md: "flex-start",
                      },

                      gap: 1.5,

                      width: {
                        xs: "100%",
                        md: "auto",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        color: "#2563eb",

                        fontSize: {
                          xs: "20px",
                          md: "22px",
                        },

                        display: "flex",
                      }}
                    >
                      {item.icon}
                    </Box>

                    <Typography
                      sx={{
                        fontWeight: 700,

                        color: "#1e3a8a",

                        fontSize: {
                          xs: "14px",
                          md: "15px",
                        },
                      }}
                    >
                      {item.title}
                    </Typography>
                  </Box>

                  {index !== 2 && (
                    <Box
                      sx={{
                        width: {
                          xs: "70%",
                          md: "1px",
                        },

                        height: {
                          xs: "1px",
                          md: "36px",
                        },

                        background: "rgba(0,87,255,.12)",
                      }}
                    />
                  )}
                </React.Fragment>
              ))}
            </Box>
          </Box>

          {/* RIGHT IMAGE */}

          <Box
            sx={{
              flex: 1,

              position: "relative",

              width: "100%",

              display: "flex",

              justifyContent: "center",
            }}
          >
            {/* <Box
              component="img"
              src={whyChooseImage}
              alt="Why Choose Comet Cleaners"
              sx={{
                width: "100%",

                maxWidth: "760px",

                display: "block",
              }}
            /> */}

            {/* Floating Badge 1 */}

            {/* <Box
              sx={{
                position: "absolute",

                top: 40,

                left: 20,

                p: 2.5,

                borderRadius: "22px",

                background: "#fff",

                boxShadow: "0 15px 40px rgba(0,87,255,.12)",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 800,

                  color: "#0057ff",

                  fontSize: "28px",
                }}
              >
                5000+
              </Typography>

              <Typography>Happy Customers</Typography>
            </Box> */}

            {/* Floating Badge 2 */}

            {/* <Box
              sx={{
                position: "absolute",

                bottom: 35,

                left: 40,

                p: 3,

                borderRadius: "22px",

                background: "linear-gradient(135deg,#0057ff,#2f8cff)",

                color: "#fff",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 800,

                  fontSize: "36px",
                }}
              >
                10+
              </Typography>

              <Typography>Years Experience</Typography>
            </Box> */}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default WhyChooseUs;